<template>
  <div>
    <div
      :style="{
        marginLeft: '13px',
        marginRight: isMobile.isMobile ? '15px' : '0px',
        overflow: 'hidden',
      }"
    >
      <md-toolbar
        :class="isMobile.isMobile ? 'headerisMobile' : 'header'"
        :style="{
          height: isMobile.isMobile ? '44px' : '64px',
          minHeight: isMobile.isMobile ? '44px' : '64px',
        }"
      >
        <span
          :style="{
            width: '130px',
            float: 'left',
            color: ' #fff',
            margin: isMobile.isMobile ? '0px 20px 0px 0px' : '20px 10px 20px 26px',
          }"
          >第三方软件列表</span
        >
        <span
          class="addCourse"
          v-hasPermi="['dev::course::add']"
          @click="openAddAndModifyCard"
          :style="{
            height: isMobile.isMobile ? '25px' : '61px',
            lineHeight: isMobile.isMobile ? '25px' : '61px',
          }"
        >
          <v-btn
            large
            class="md-button md-success"
            :style="{
              marginTop: isMobile.isMobile ? '-5px' : '0px',
              height: isMobile.isMobile ? '25px' : '',
              lineHeight: isMobile.isMobile ? '25px' : '',
            }"
          >
            <span class="iconfont icon-tianjia" style="font-size: 17px; margin-right: 2px"></span
            >新建
            <!-- <md-tooltip md-direction="top">添加课程</md-tooltip> -->
          </v-btn>
        </span>
        <!-- <span
        class="material-icons"
        v-if="isMobile.isMobile"
        style="color: #fff; float: left; margin-right: 8px"
        @click.stop="toggleSidebar"
      >
        list
      </span> -->

        <md-button
          v-if="isMobile.isMobile"
          class="md-toolbar-toggle md-just-icon md-round md-simple md-toolbar-section-end"
          :class="{ toggled: $sidebar.showSidebar }"
          :style="{ float: 'right', color: '#fff !important', height: '25px' }"
          @click.stop="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
      </md-toolbar>
    </div>
    <v-card class="courseListWrap">
      <div>
        <div class="coureWraps">
          <v-card-text style="padding: 0px; min-height: 550px; position: relative">
            <ThirdPartySoft></ThirdPartySoft>
          </v-card-text>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ThirdPartySoft from '/src/components/Cards/ThirdPartySoft.vue';
export default {
  components: {
    ThirdPartySoft,
  },
  computed: {
    ...mapGetters(['courseList', 'cardType', 'courseListPage', 'isMobile']),
    pageCount() {
      return this.pagination.total
        ? Math.ceil(this.pagination.total / this.pagination.itemsPerPage)
        : 0;
    },
    cardType() {
      return this.$store.state.task.cardType;
    },
    courseListPage() {
      return this.$store.state.task.courseListPage;
    },
  },
  created() {
    this.toggle_exclusive = this.cardType;
    this.getTab();
  },
  data() {
    return {
      cascaderKey: 0,
      optionsValue: ['all'],
      cascaderProps: {
        label: 'name',
        value: 'code',
        lazy: false,
      },

      options: [
        { value: 'all', label: '全部', level: 0 },
        { value: 'bjrs', label: '毕节人社', level: 0 },
        { value: 'bk', label: '本科', level: 0 },
        { value: 'gz', label: '高职', level: 0 },
        { value: 'zz', label: '中职', level: 0 },
        { value: 'gj', label: '技师学院', level: 0 },
        { value: 'jx', label: '技校', level: 0 },
        { value: 'qy', label: '企业', level: 0 },
      ],
      btns: [['Removed', '0']],
      colors: ['deep-purple accent-4'],
      items: [...Array(4)].map((_, i) => `Item ${i}`),
      x: true,
      y: true,

      majorGroup: '',
      majorGroup2: '',
      listData1: [
        { code: 'bjrs', name: '毕节人社' },
        { code: 'bk', name: '本科' },
        { code: 'gz', name: '高职' },
        { code: 'zz', name: '中职' },
        { code: 'gj', name: '技师学院' },
        { code: 'jx', name: '技校' },
        { code: 'qy', name: '企业' },
      ],
      listData2: [],
      listData3: [],
      type: 'bjrs',
      queryform: {
        one: {
          name: '适用',
          code: '',
        },
        level: '',
        parentCode: {
          name: '专业大类',
          code: '',
        },
        three: {
          name: '专业类',
          code: '',
        },
      },
      typeList: [
        { code: '', name: '全部' },
        { code: 'bjrs', name: '毕节人社' },
        { code: 'bk', name: '本科' },
        { code: 'gz', name: '高职' },
        { code: 'zz', name: '中职' },
        { code: 'gj', name: '技师学院' },
        { code: 'jx', name: '技校' },
        { code: 'qy', name: '企业' },
      ],
      typeValueArr: [],
      typeArr: [],
      centerValue: '',
      rightValue: '',
      left_refer_list: [
        { id: 1, value: 'bjrs', name: '毕节人社', isCheck: false },
        { id: 2, value: 'bk', name: '本科', isCheck: false },
        { id: 3, value: 'gz', name: '高职', isCheck: false },
        { id: 4, value: 'zz', name: '中职', isCheck: false },
        { id: 5, value: 'gj', name: '技师学院', isCheck: false },
        { id: 6, value: 'jx', name: '技校', isCheck: false },
        { id: 7, value: 'qy', name: '企业', isCheck: false },
      ],
      centerListLoading: false, //中间loading
      rightListLoading: false, //中间loading

      center_refer_list: [],
      copy_center_refer_list: [],
      right_refer_list: [],
      copy_right_refer_list: [],
      select: { state: '全部', abbr: 'ALL' },
      items: [
        { state: '全部', abbr: 'ALL' },
        { state: '已发布', abbr: 'Published' },
      ],
      // 分页
      toggle_exclusive: 0,
      scoureImg: require('/public/img/log.png'),

      headers: [
        {
          text: '序 号',
          align: 'start',
          value: 'num',
          width: 90,
        },
        { text: '名 称', align: 'start', value: 'name', width: 300 },
        { text: '签约院校', align: 'start', value: 'university' },
        { text: '学院/系', align: 'start', value: 'college' },
        { text: '教研团队', align: 'start', value: 'team' },
        { text: '适 用', align: 'start', value: 'refer', width: 120 },
        { text: '负责人', align: 'start', value: 'manager', width: 120 },
        {
          text: '操作',
          align: 'center',
          value: 'optionone',
          sortable: false,
          width: 140,
        },
      ],
      tableData: [],
      currentSort: 'name',
      currentSortOrder: 'asc',
      queryParams: {},
      queryformVisible: false,
      //本地缓存
      saveCourseForm: {
        currentPage: '',
        perPage: '',
        name: '',
        refer: '',
        majorGroup: '',
        majorGroup2: '',
      },
      tooltipVisible: false,
      tooltipValue: '全部',
    };
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    selectTab(value = 0) {
      window.localStorage.setItem('courseTab', value);
      this.tab = value;
      this.optionsValue = ['all'];
    },
    getTab() {
      if (window.localStorage.getItem('courseTab')) {
        let tabs = parseInt(window.localStorage.getItem('courseTab'));
        this.tab = tabs;
      }
    },
    onClick(data) {
      this.optionsValue = data.path;
      this.$refs.ThirdPartySoft.selectCard(this.optionsValue);
      // this.$refs.SimClassCard.selectCard(this.optionsValue);;
      this.mouseenter(data);
    },
    mouseenter(data) {
      let str = '';
      if (data && data.pathLabels) {
        if (data.pathLabels.length == 1) {
          str = data.pathLabels[0];
          this.tooltipValue = str;
        } else if (data.pathLabels.length == 2) {
          str = data.pathLabels[0] + '/' + data.pathLabels[1];
          this.tooltipValue = str;
        } else if (data.pathLabels.length == 3) {
          str = data.pathLabels[0] + '/' + data.pathLabels[1] + '/' + data.pathLabels[2];
          this.tooltipValue = str;
        }
        this.tooltipVisible = true;
      } else {
        this.tooltipValue = '全部';
      }
    },
    mouseDown() {
      this.tooltipVisible = false;
    },

    onchange(data) {},

    async openClient(item) {
      const params = encodeURIComponent(
        JSON.stringify({
          token: localStorage.getItem('token'),
          course: item.project.course,
          projectId: item.project._id,
          version: item.version,
          platform: item.platform ?? 'PC',
          // , runtime: 'meta_trial'
          runtime: process.env.VUE_APP_RUNTIME,
        })
      );
      location.href = `MetaSpaceProject://${params}`;
    },
    setBtnSelect() {
      this.toggle_exclusive = !this.toggle_exclusive;
    },
    resetquery() {
      this.queryform.parentCode = {
        name: '专业大类',
        code: '',
      };
      this.queryform.three = {
        name: '专业类',
        code: '',
      };
      this.listData2 = [];
      this.listData3 = [];
    },

    setqueryParamsName(name) {
      this.$refs.ThirdPartySoft.saveCourseForm.name = name;
    },

    openAddAndModifyCard() {
      this.$router.push({ path: '/thirdPartySoft/add' });
    },
  },
  mounted() {
    let _this = this;
    this.$EventBus.$on('setCardStyle', function (type) {
      _this.toggle_exclusive = type;
    });
    if (this.$route.query && this.$route.query.tab) {
      this.tab = parseInt(this.$route.query.tab);
    }
  },
};
</script>

<style scoped>
/* 影响全局表格样式 */
@media (max-width: 599px) {
  .selectBtn {
    flex: 1;
    /* width: 98%; */
    margin: 0 auto;
    text-align: right;
    padding: 0 8px 0 0;
  }
}

.header {
  background: #4caf50 !important;
  overflow: hidden;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  margin: 0px 0px 0px 0px;
}

.headerisMobile {
  background: #4caf50 !important;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  margin: 10px 0px;
}
.quertHeader {
  padding: 0 15px;
}

.theme--dark.v-btn.v-btn--has-bg {
  background: #2e694b !important;
}
.addCourse {
  float: left;
  margin-left: -20px;
  height: 61px;
  line-height: 61px;
  /* margin-top: 10px; */
}
.addCourse svg {
  width: 1.4em !important;
  height: 1.4em !important;
  fill: currentColor;
  overflow: hidden;
  /* transform: translateY(6px); */
  color: #fff;
  cursor: pointer;
}

.selectBtn {
  float: right;
  margin-right: 10px;
  height: auto;
  overflow: hidden;
  height: 62px;
  line-height: 62px;
  cursor: pointer;
}

.selectBtn svg {
  width: 1.5em !important;
  height: 1.3em !important;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  /* color: #4caf50; */
}

.toggleBtn >>> svg {
  width: 1.5em !important;
  height: 1.5em !important;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  /* color: #fff; */
}
.toggleBtn {
  /* background: #fff !important; */
  transform: translateY(5px);
}

/* .icon1:hover {
    color: #fff;
  } */

.theme--light.v-btn.v-btn--has-bg {
  /* background: #4caf50; */
}

/* .selectBtn >>> .v-item--active,
  .v-btn--active {
    color: #43a047;
  } */

.queryWrap {
  /* margin-top: 18px; */
  width: auto;
  float: right;
}

.queryWrap .v-input >>> .v-input__control .v-input__slot .v-label {
  color: #fff !important;
}
.queryWrap .v-input >>> .v-input__control .v-input__slot::before {
  border-color: #fff;
}

.queryWrap .v-input >>> .v-input__control .v-input__slot .v-select__selections {
  color: #fff !important;
}

.queryWrap .v-input >>> .v-input__control .v-input__slot .v-input__append-inner .v-input__icon i {
  color: #fff !important;
}

.coureWraps {
  /* min-height: 650px; */
  overflow-x: hidden;
  /* padding-top: 20px; */
  /* max-height: 660px; */
  /* background-image: url('@/assets/socore_Img.png');
    background-image: url('../../assets/img/socore_Img'); */
}
.md-content {
  width: 100%;
  max-height: 850px;
  overflow: auto;
}
.cardStyle {
  width: 24% !important;
  height: 200px;
  float: left;
}

.coureListImg {
  width: 100%;
  transition: 0.2s;
}

.courseList {
  /* margin: 10px 0; */
  height: 245px;
  max-height: 245px;
  cursor: pointer;
}

.v-card {
  position: relative;
  overflow: hidden;
}

/* .pubInput{
    width: 100px !important;
  }
  
  .pubInput >>>.v-input__control{
    width: 100px !important;
      
  } */

.coureWraps >>> .v-card:hover .openClient {
  display: block;
}
.openClient {
  position: absolute;
  right: 10px;
  /* top: 0; */
  bottom: 5px;
  margin: auto;
  width: 32px;
  border-radius: 5px;
  height: 32px;
  z-index: 888;
  cursor: pointer;
  /* background-image: url('../../assets/img/openClient.png'); */
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: none;
}

.courseList:hover .coureListImg {
  opacity: 0.8;
}

.md-layout-item {
  padding: 4px 10px 4px 10px;
}

.btnSelect {
  /* padding: 5px 6px; */
  font-size: 20px;
  color: #fff;
}

.selectWrap {
  background: #fff;
}

.listWrap {
  background: #000000a3;
  margin-top: 0px;
  margin-left: 20px;
  /* border: 1px solid #fff; */
  border-radius: 5px;
}

.listItem {
  cursor: pointer;
  min-height: 38px;
  padding: 0 10px;
  font-size: 13px;
}
.listItem:hover {
  background-color: #494949 !important;
}
.icon-shanchutianchong {
  margin-right: 7px;
  color: #fff;
}

.selectWrapAdd {
  display: inline-block;
  position: relative;
}

/* >>> .sortable{
    padding: 0 6px !important;
  } */

.conWrap {
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0px;
}

#coursefilterWrap {
  margin-top: 18px;
  margin-left: 10px;
  /* width: 320px; */
}

#coursefilterWrap >>> .el-input:hover {
  /* box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12); */
  box-shadow: 0 0 6px 1px #70707052;
  border-radius: 4px;
}
#coursefilterWrap >>> .el-input .el-input__inner {
  border: none;
  background: #4caf50 !important;
  color: #fff;
  font-weight: 700;
}
#coursefilterWrap >>> .el-input .el-input__inner::placeholder {
  color: #fff;
}
#coursefilterWrap >>> .el-input .el-input__suffix {
  color: #fff;
}

.el-cascader-menu {
  max-width: 250px;
}

.toopZindex {
  z-index: 99999;
}

.custom-tab {
  margin-left: 0px;
  margin-right: 0px;
}
.filterValue {
  margin: 0 auto;
  width: 300px;
  /* position: absolute;
    top: 10px;
    right: 10px; */
  z-index: 99;
}

.filterValue .v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.messageWrap {
  width: 100px;
  position: absolute;
  top: 10px;
  right: 300px;
  z-index: 900;
}

.courseListWrap {
  margin-left: 13px;
}

@media (max-width: 600px) {
  .titleStyle {
    margin: 0px 0px 0px 10px !important;
  }
  .filterValue {
    width: 100%;
    margin-top: 10px;
    padding-right: 10px;
    padding-left: 10px;
  }
  .ahoverdown {
    width: 95px;
  }
  .noDataGuJia {
    width: 98%;
    position: absolute;
    top: 100px;
  }
  .courseListWrap {
    margin-left: 15px;
    margin-right: 15px;
  }

  .headerisMobile {
    display: block !important;
  }
  .filterValue {
    margin: 0 auto;
    width: 300px;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 99;
  }
}
</style>
